import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountTitleAuxiliaryBalance.query,
    method: 'post',
    data: requestBody
  })
}
// 加载科目辅助余额列表
export function loadAccountTitleAuxiliaryBalance(requestBody) {
  return request({
    url: URL.finance.accountTitleAuxiliaryBalance.loadAccountTitleAuxiliaryBalance,
    method: 'post',
    data: requestBody
  })
}
